/* @ngInject */
const mySterileForm = () => {
  return {
    restrict: 'E',
    scope: {
      sterile: '=mySterile',
      enableValidator: '=?',
    },
    template: require('./mySterileForm.html'),
    /* @ngInject */
    controller: ($scope, $$sterile) => {
      $scope.fieldsOptions = $$sterile.metadata.fields
    },
    link: {
      pre: (scope, element, attrs) => {  },
      post: (scope, element, attrs, ctrl) => { },
    },
  }
}
export default mySterileForm



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/sterile/directives/forms/mySterileForm.js